import type { SyntheticEvent } from 'react';

import type { EventHandlers } from '@atlaskit/editor-common/ui';

export const rendererEventHandlers: EventHandlers = {
	link: {
		onClick: (event: SyntheticEvent<HTMLAnchorElement>, url?: string) => {
			// Intercept link event and open in another window stripping any opener or referrer info
			event.preventDefault();
			window?.open(url, '_blank', 'noopener noreferrer');
		},
	},
};
